import {getDevice,getCharacteristic,writeCharacteristic,rememberDevice,getRememberedDeviceId} from "./ble.js"
import {sleep} from "./common.js"

const DEFAULT_TIMEOUT = 15000;
const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_RETRY_DELAY = 1000;

// 这些错误重试没有意义，直接失败
const NO_RETRY_FRAGMENTS = [
    "Bluetooth adapter not available",
    "User cancelled",
];

export async function unlockProcess(lock, callback, options = {}) {
    const timeout = options.timeout ?? DEFAULT_TIMEOUT;
    const maxRetries = options.maxRetries ?? DEFAULT_MAX_RETRIES;
    const retryDelay = options.retryDelay ?? DEFAULT_RETRY_DELAY;

    let lastErr = null;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        if (attempt > 1) {
            callback(0, `开锁失败，第 ${attempt} 次尝试`);
            await sleep(retryDelay);
        } else {
            callback(0, "等待选择设备");
        }
        try {
            await performUnlock(lock, callback, timeout);
            callback(100, "完成");
            return;
        } catch (err) {
            lastErr = err;
            console.error("开锁失败：", err);
            if (attempt >= maxRetries || !shouldRetry(err)) {
                callback(-1, `开锁失败（共尝试 ${attempt} 次）`, lastErr);
                return;
            }
        }
    }
}

async function performUnlock(lock, callback, timeout) {
    const device = await getDevice(lock.D_SERV, getRememberedDeviceId(deviceKey(lock)));
    rememberDevice(deviceKey(lock), device);
    callback(40, "开始连接");

    const characteristic = await withTimeout(
        getCharacteristic(device, lock.D_SERV, lock.D_CHAR),
        timeout,
        "连接超时"
    );
    callback(70, "写入....");

    await withTimeout(
        writeCharacteristic(characteristic, getPwd(lock.D_SEC)),
        timeout,
        "写入超时"
    );
}

function deviceKey(lock) {
    return lock.D_Mac || lock.D_SERV || lock.label;
}

function withTimeout(promise, ms, message) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error(message)), ms);
        promise.then(
            value => { clearTimeout(timer); resolve(value); },
            err => { clearTimeout(timer); reject(err); }
        );
    });
}

function shouldRetry(err) {
    const message = err && err.toString();
    if (!message) return false;
    return !NO_RETRY_FRAGMENTS.some(fragment => message.includes(fragment));
}

function getPwd(secret) {
    let buffer = new ArrayBuffer(1024);
    let view = new DataView(buffer);
    let offset = 0;
    let pw = Math.floor(Math.random() * 1000000);
    view.setUint8(offset++, 208);
    let len = secret.length + 2 + 2 + 10;
    view.setUint8(offset++, len);
    for (let i = 0; i < secret.length; i++) {
        view.setUint8(offset++, secret.charCodeAt(i));
    }
    view.setUint8(offset++, 165);
    for (let i = 0; i < 6; i++) {
        view.setUint8(offset++, pw % 10);
        pw = Math.floor(pw / 10);
    }
    view.setUint8(offset++, 73);
    view.setUint8(offset++, 68);
    view.setUint8(offset++, 48);
    view.setUint8(offset++, 49);

    view.setUint8(offset++, 167);

    return buffer.slice(0, offset);
}